import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from "react";
import Property from "@episerver/spa-core/Components/Property";
import { getImageProps } from "app/utilities/ImageProps";
import { DomainMarketCode } from "../../../utilities/domain/domainConstants";
import { transactionType } from "../../Page/TransactionSummaryPage/Shared/Constants";
import { checkSectionValid } from "../../Page/TransactionSummaryPage/Shared/HelperFunctions";

const TransactionBanner = ({ data, context, bannerDetails, dealType, marketCode }) => {
  const showComponent = checkSectionValid(bannerDetails);
  let bannerData = "";
  const [isMobile, setIsMobile] = useState(false);
  const isGolan = marketCode === DomainMarketCode.GOLAN;

  if (showComponent) bannerData = setBannerData(dealType, data, isMobile);

  useEffect(() => {
    function reportWindowSize() {
      setIsMobile(window.innerWidth < 450);
    }

    window.addEventListener("resize", reportWindowSize);

    return () => window.removeEventListener("resize", reportWindowSize);
  }, []);

  return showComponent ? (
    <div className={`transaction-banner${isGolan ? ' transaction-banner--golan' : ''}`}>
      <div className="transaction-banner__welcome-text">
        <span className="transaction-banner__name">
          שלום {bannerDetails.accountName},{" "}
        </span>
        <Property
          iContent={data}
          field={bannerData.topic}
          context={context}
          className="transaction-banner__property"
        />
      </div>
      <Image className="transaction-banner__image"
        {...getImageProps(bannerData.image, context)} />
    </div>
  ) : null;
};

function setBannerData(dealType, data, isMobile) {
  const bannerData = {};
  switch (dealType) {
    case transactionType.Provide:
      bannerData.image = isMobile
        ? data.transactionBannerProvideMobileImage
        : data.transactionBannerProvideDeskImage;
      bannerData.topic = "transactionBannerProvideTopic";
      break;
    case transactionType.Change:
      bannerData.image = isMobile
        ? data.transactionBannerChangeMobileImage
        : data.transactionBannerChangeDeskImage;
      bannerData.topic = "transactionBannerChangeTopic";
      break;
    case transactionType.Disconnect:
      bannerData.image = isMobile
        ? data.transactionBannerDisconnectMobileImage
        : data.transactionBannerDisconnectDeskImage;
      bannerData.topic = "transactionBannerDisconnectTopic";
      break;
    case transactionType.Accessory:
      bannerData.image = isMobile
        ? data.transactionBannerAccessoryMobileImage
        : data.transactionBannerAccessoryDeskImage;
      bannerData.topic = "transactionBannerAccessoryTopic";
      break;
    case transactionType.CancelDeal:
      bannerData.image = isMobile
        ? data.transactionBannerCancelDealMobileImage
        : data.transactionBannerCancelDealDeskImage;
      bannerData.topic = "transactionBannerCancelDealTopic";
      break;
    default:
      bannerData.image = isMobile
        ? data.transactionBannerProvideDeskImage
        : data.transactionBannerProvideMobileImage;
      bannerData.topic = "transactionBannerProvideTopic";
  }

  return bannerData;
}

export default TransactionBanner;
